/* eslint-disable array-callback-return */
export const scriptEncoding = (websiteData) => {
  const data = [];

  if (typeof websiteData === "string") {
    const a = websiteData?.split("</script>");
    a.forEach((ele) => {
      if (ele.includes("async")) {
        const da = ele.match(/(((https?:\/\/)|(www\.))[^\s]+)/g);
        if (da) {
          data.push({
            isAsync: true,
            src: da[0]?.replace(/["'>]+$/, ""),
            body: null,
          });
        } else {
          const srcValue = ele.match(/src="([^"]*)"/); // Extract src attribute value
          if (srcValue && srcValue[1].startsWith("//")) {
            // If src attribute value starts with '//', it's already a complete URL
            const updatedSrc = "https:" + srcValue[1];
            data.push({
              isAsync: true,
              src: updatedSrc,
              body: null,
            });
          }
        }
      } else {
        data.push({
          body: ele?.slice(8),
        });
      }
    });
  }
  return data.map((item) => {
    if (item.isAsync) {
      return (
        <script async src={item.src}>
          {" "}
        </script>
      );
    }
    if (item.body) {
      return <noscript dangerouslySetInnerHTML={item.body}></noscript>;
    }
  });
};